module.exports = __webpack_public_path__ + "static/img/case5.7fe5cf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/case5.jpg
// module id = 2Eqd
// module chunks = 0